/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RdsNativePitrAdvancedConfig } from '../models/RdsNativePitrAdvancedConfig';
import { RdsNativePitrClusterAdvancedConfig } from '../models/RdsNativePitrClusterAdvancedConfig';
import { RdsNativePitrNetworkConfig } from '../models/RdsNativePitrNetworkConfig';

export class RestoreRdsNativePitrRequest {
  /**
  * The date and time to restore the RDS database to (in UTC). Must be within the backup retention period (available PITR window).  Either restoreToTime or advancedOptions.isRestoreToLatest must be specified (not both).  Format: ISO 8601 (e.g., \"2025-01-04T14:30:00Z\") 
  */
  'restoreToTime'?: Date;
  /**
  * Name for the restored database (cluster or instance). Must be unique in your AWS account/region.  - For Aurora: This will be the cluster identifier - For RDS instances: This will be the instance identifier 
  */
  'targetDatabaseName': string;
  /**
  * Instance class for the database instance.  - For Aurora: Instance class for the primary (writer) instance - For RDS instances: Instance class for the restored instance  Example: db.r5.large, db.r5.xlarge, db.r6g.2xlarge, db.t3.medium 
  */
  'primaryInstanceClass': string;
  /**
  * Availability zone for the instance. If not specified, AWS chooses automatically. 
  */
  'primaryAvailabilityZone'?: string;
  'network'?: RdsNativePitrNetworkConfig | null;
  'advancedOptions'?: RdsNativePitrAdvancedConfig | null;
  'clusterAdvancedOptions'?: RdsNativePitrClusterAdvancedConfig | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreToTime",
      "baseName": "restoreToTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "targetDatabaseName",
      "baseName": "targetDatabaseName",
      "type": "string",
      "format": ""
    },
    {
      "name": "primaryInstanceClass",
      "baseName": "primaryInstanceClass",
      "type": "string",
      "format": ""
    },
    {
      "name": "primaryAvailabilityZone",
      "baseName": "primaryAvailabilityZone",
      "type": "string",
      "format": ""
    },
    {
      "name": "network",
      "baseName": "network",
      "type": "RdsNativePitrNetworkConfig",
      "format": ""
    },
    {
      "name": "advancedOptions",
      "baseName": "advancedOptions",
      "type": "RdsNativePitrAdvancedConfig",
      "format": ""
    },
    {
      "name": "clusterAdvancedOptions",
      "baseName": "clusterAdvancedOptions",
      "type": "RdsNativePitrClusterAdvancedConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreRdsNativePitrRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

